import { Validator } from '@vista-digital/validator';
import { FieldFormatType } from '../../../types/form/field-format-type';
import { numberFieldValidationConfigValidator, numberFieldValidationConfigValidatorSchema, otherFieldValidationConfigValidator } from '../../../types/form/field-validation-config';
export const defaultGiftCardCheckerFormValidationConfig = {
    cardNumber: { type: FieldFormatType.Number, required: true },
    pin: { type: FieldFormatType.Number, required: true, minLength: 1, maxLength: 20 },
    captcha: { type: FieldFormatType.Other, required: true }
};
export const giftCardCheckerFormValidationConfigValidator = Validator.object({
    cardNumber: Validator.object(Object.assign(Object.assign({}, numberFieldValidationConfigValidatorSchema), { required: Validator.isEqualTo(true) })),
    pin: numberFieldValidationConfigValidator,
    captcha: otherFieldValidationConfigValidator
});
